import { render, staticRenderFns } from "./GuppyImageMessage.vue?vue&type=template&id=3aff5da8&"
import script from "./GuppyImageMessage.vue?vue&type=script&lang=js&"
export * from "./GuppyImageMessage.vue?vue&type=script&lang=js&"
import style0 from "./GuppyImageMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports